/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    draggable: PropTypes.bool,
    link: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    link: false,
    draggable: false,
    componentClass: 'li',
};

const ListItem = (props) => {
    const classNames = [
        'c-list__item',
        props.link ? 'c-list__item--link' : '',
        props.draggable ? 'c-list__item--draggable' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

ListItem.propTypes = propTypes;

ListItem.defaultProps = defaultProps;

export default ListItem;
